import styled from 'styled-components';
import {Button} from '../../../ui-kit/Buttons/Button';

export const ButtonSend = styled(Button).attrs({
  type: 'secondary',
})`
  min-height: 50px;
  min-width: 125px;
`;
